import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {ApiResourceService} from "../../apiResource/apiResource.service";
import {
    ResponseForConvertSearchAddOnAfx2jsonType
} from "@afidium/ts-facade/model/responseForConvertSearchAddOnAfx2jsonType";
import {ServiceInServiceSearchAddon} from "@afidium/ts-facade/model/serviceInServiceSearchAddon";
import {HostCodeTargetType} from "@afidium/ts-facade/model/hostCodeTargetType";
import {EHosts} from "../../../enums/EHosts";

const AIR: string = 'air';
const SERVICES: string = 'services';
const SEARCH: string = 'search';

@Injectable({
  providedIn: 'root'
})
export class AirServicesResourceService {

    constructor(
        private readonly apiResource: ApiResourceService
    ) { }

    public searchAddOns(
        bookingSyscode: string,
        bookingHost: HostCodeTargetType,
        servicesArray: ServiceInServiceSearchAddon[]
    ): Observable<ResponseForConvertSearchAddOnAfx2jsonType> {
        if(bookingHost.code === EHosts.GALILEO){
            bookingHost.code = EHosts.TRAVELPORT;
        }
        return this.apiResource.postOne<{}, any>(
            this.apiResource.getApiUrl(
                AIR,
                SERVICES,
                SEARCH,
            ),
            {
                booking: {
                    syscodeValue: bookingSyscode,
                    host: bookingHost
                },
                servicesArray
            }
        );
    }
}
